// @preval
import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../tailwind.config';

const twConfig = resolveConfig(tailwindConfig);

export const twColors = twConfig.theme.colors;
export const twPadding = twConfig.theme.padding;
export const twFontSize = twConfig.theme.fontSize;
export const twScreens = twConfig.theme.screens;
export const twFontFamily = twConfig.theme.fontFamily;
